"use client";
import { jsx as n } from "react/jsx-runtime";
import { SelectContent as o } from "../../atoms/Select/Select.mjs";
import { cn as m } from "../../../utils/utils.mjs";
const a = ({ className: t, children: e, ...r }) => /* @__PURE__ */ n(o, { className: m("dark:bg-neutral-dark-200 rounded-3xl py-4 min-w-50", t), ...r, children: e });
export {
  a as MediaSelectContent
};
